/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Rename_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose a name you will recognise. It is shown here and wherever this connection is linked." |
*
* @param {My_Integrations_Rename_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_rename_description = /** @type {((inputs?: My_Integrations_Rename_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Rename_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Namen, den Sie wiedererkennen. Er wird hier und überall dort angezeigt, wo diese Verbindung verknüpft ist.")
	return /** @type {LocalizedString} */ ("Choose a name you will recognise. It is shown here and wherever this connection is linked.")
});